import { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Divider, Typography } from '@mui/material';

import Schema from '../../../../../../lib/paths/zuwendungsantrag_Zuwendungsantrag_Paths.json';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { get } from 'lodash';
import { concat } from 'lodash';
import { cloneDeep } from 'lodash';
import { set } from 'lodash';
import ComponentFieldBox from '../../../antrag-component/ComponentFieldBox';
import { BICValidation, EmailValidation, IBANValidation, Required } from '../../../../../../lib/validation/ValidationTypes';
const P = Schema.attributes;

const Antragsteller: FC<{}> = () => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();

	const handleAddAP = () => {
		try {
			let appCopy = cloneDeep(application);
			let data = { Position: '' };
			set(
				appCopy,
				`${P.Antragstellerin_Ansprechpartnerin.path}.${get(application, P.Antragstellerin_Ansprechpartnerin.path, []).length}`,
				data,
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Adding Ansprechpartner ', err);
		}
	};

	const handleDeleteAP = (index: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allAnsprechpartner = get(appCopy, P.Antragstellerin_Ansprechpartnerin.path, []);
			set(
				appCopy,
				P.Antragstellerin_Ansprechpartnerin.path,
				allAnsprechpartner.filter((_: any, i: number) => i !== index),
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Ansprechpartner ', err);
		}
	};

	return (
		<>
			<Typography variant="h3">Kontaktinformationen</Typography>
			<Typography>Organisation</Typography>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={OrganisationStruc()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={OrganisationExtrasStruc()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
			</Grid2>

			<Divider sx={{ mt: '2rem', mb: '0.5rem' }} />
			<Typography>Bankdaten</Typography>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={BankErstSpalte()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={BankZweitepalte()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
			</Grid2>

			<Box sx={{ mt: '2rem' }}>
				<Divider />
				<Typography variant="h5" sx={{ margin: '1rem 0' }}>
					Ansprechpartner
				</Typography>
				<Grid2 spacing={6} container>
					{get(application, P.Antragstellerin_Ansprechpartnerin.path, []).map((_ele: any, i: number) => {
						return (
							<Grid2 key={i} sm={6}>
								<ComponentFieldBox
									index={i}
									title="Ansprechpartner"
									onDelete={() => handleDeleteAP(i)}
									showDeleteButton={!readOnly}
								>
									<CreateForm
										formStruc={mapOrgaAP(AnsprechpartnerStruc(), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={readOnly}
									/>
								</ComponentFieldBox>
							</Grid2>
						);
					})}
				</Grid2>
				<Button sx={{ mt: '3rem' }} endIcon={<AddIcon />} onClick={handleAddAP} disabled={readOnly}>
					Ansprechpartner hinzufügen
				</Button>
			</Box>
		</>
	);
};

export default Antragsteller;

const OrganisationStruc = () => {
	return [
		{
			fields: [P.Antragstellerin_Name, P.Antragstellerin_Rechtsform, P.Antragstellerin_Strasse_Hausnummer],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{ fields: [P.Antragstellerin_PLZ, P.Antragstellerin_Ort], userProps: { columnToDivide: 2 } },
		{ fields: [P.Antragstellerin_E_Mail, P.Antragstellerin_Tel], userProps: { columnToDivide: 2 } },
	];
};

const OrganisationExtrasStruc = () => {
	return [
		{
			fields: [P.Antragstellerin_Stadtteil],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [P.Antragstellerin_Schulform, P.Antragstellerin_Vereinsregister_Auszug],
			userProps: { columnToDivide: 2 },
		},

		{
			fields: [P.Antragstellerin_Vereinskennziffer_Vereinsregisternummer],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [P.Antragstellerin_Finanzamt, P.Antragstellerin_Steuernummer_Ust_ID],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Antragstellerin_Handelsregister, P.Antragstellerin_In_Welcher_Sparte_Taetig],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Antragstellerin_Zum_Vorzugsteuerabzug_Berechtigt],
			userProps: { columnToDivide: 1 },
		},
	];
};

const BankErstSpalte = () => {
	return [
		{
			fields: [P.Antragstellerin_Bankverbindung_Geldinstitut, P.Antragstellerin_Bankverbindung_Kontoinhaber],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

const BankZweitepalte = () => {
	return [
		{
			fields: [
				{ ...P.Antragstellerin_Bankverbindung_IBAN, validation: [{ validateFunction: IBANValidation }] },
				{ ...P.Antragstellerin_Bankverbindung_BIC, validation: [{ validateFunction: BICValidation }] },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

const AnsprechpartnerStruc = () => {
	return [
		{
			fields: [P.Antragstellerin_Ansprechpartnerin.schema.attributes.Position],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				P.Antragstellerin_Ansprechpartnerin.schema.attributes.Vorname,
				P.Antragstellerin_Ansprechpartnerin.schema.attributes.Nachname,
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				P.Antragstellerin_Ansprechpartnerin.schema.attributes.Telefonnummer,
				{
					...P.Antragstellerin_Ansprechpartnerin.schema.attributes.E_45_Mail_45_Adresse,
					validation: [{ validateFunction: Required }, { validateFunction: EmailValidation }],
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
};

const mapOrgaAP = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Antragstellerin_Ansprechpartnerin.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Antragstellerin_Ansprechpartnerin.path.length),
				};
			}),
		};
	});
	return result;
};

export const GetAntragstellerFormStruc = (application: any) => {
	const orgaAPLength = get(application, P.Antragstellerin_Ansprechpartnerin.path, []).length;

	let result: any[] = [];
	for (let i = 0; i < orgaAPLength; i++) {
		mapOrgaAP(AnsprechpartnerStruc(), i).forEach((ele: any) => {
			result.push(ele);
		});
	}

	const antragStellerStruc = concat(result, BankErstSpalte(), BankZweitepalte(), OrganisationStruc(), OrganisationExtrasStruc());
	return antragStellerStruc;
};
